// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  key: __t.string().primaryKey(),
  identity: __t.identity(),
  kind: __t.string(),
  species: __t.string(),
  count: __t.u32(),
  how: __t.string(),
  best: __t.f32(),
  firstAt: __t.timestamp().name("first_at"),
  lastAt: __t.timestamp().name("last_at"),
});
